export default "__VITE_ASSET__CCGHJ5hM__"